import { ScrollArea } from '@/components/ui/scroll-area';

export default function RequirementsScroll() {
  return (
    <div>
      <h2>SAS BI Data Requirements</h2>
      <ScrollArea className="h-[800px] w-[1000px] rounded-md border p-4">
        <div className="space-y-4 text-sm leading-relaxed">
          <p>
            <strong>To ensure data integrity of the AWMS database</strong> (thus preventing any odd behaviours on the
            user interface), the following are <strong>hard requirements</strong> for the SAS BI data exported to AWMS.
            These are critical—violating them may cause the application to crash.
          </p>
          <div>
            <h3 className="font-semibold">Staff and Unit Data</h3>
            <ul className="ml-4 list-inside list-disc">
              <li>
                <code>faculty</code>, <code>faculty_org_code</code>, and <code>year</code> must not be empty.
              </li>
              <li>
                <code>school</code> and <code>school_org_code</code> must not be empty.
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold">Staff Data</h3>
            <ul className="ml-4 list-inside list-disc">
              <li>
                A staff member must be associated with only one school at a given point in time. A staff should not have
                multiple schools at the same time.
              </li>
              <li>
                For each combination of <code>employee_no</code> and <code>year</code>, only one record is allowed with
                consistent values for:
                <ul className="ml-4 list-inside list-disc">
                  <li>first name</li>
                  <li>surname</li>
                  <li>school</li>
                  <li>discipline</li>
                  <li>emp status</li>
                  <li>emp status desc</li>
                  <li>work function desc</li>
                  <li>work function abbr</li>
                  <li>classification</li>
                  <li>FTE</li>
                  <li>school_org_code</li>
                  <li>faculty</li>
                  <li>faculty_org_code</li>
                  <li>aqf</li>
                </ul>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold">Unit Data</h3>
            <ul className="ml-4 list-inside list-disc">
              <li>
                <code>campus</code>, <code>study mode</code>, <code>study period</code>, and <code>year</code> must not
                be empty.
              </li>
              <li>Each unit must have only one school per year.</li>
              <li>
                For each combination of <code>unit_code</code>, <code>year</code>, and <code>study period</code>, only
                one <code>employee_no</code> is allowed.
              </li>
              <li>
                For each combination of <code>unit_code</code>, <code>year</code>, <code>study period</code>,{' '}
                <code>campus</code>, and <code>study mode</code> only one record is allowed for:
                <ul className="ml-4 list-inside list-disc">
                  <li>max enrollment quota</li>
                  <li>previous year enrolments</li>
                  <li>taught weeks</li>
                </ul>
              </li>
              <li>
                For each combination of <code>unit_code</code>, <code>year</code>, <code>study period</code>,{' '}
                <code>campus</code>, <code>study mode</code> and <code>activity type</code>, only one record is allowed
                for:
                <ul className="ml-4 list-inside list-disc">
                  <li>activity duration</li>
                  <li>duration measure</li>
                  <li>max class size</li>
                </ul>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold">HDR Data</h3>
            <ul className="ml-4 list-inside list-disc">
              <li>
                For each combination of <code>employee_no</code>, <code>year</code>, <code>student_id</code>, and{' '}
                <code>unit_code</code>, only one record is allowed with:
                <ul className="ml-4 list-inside list-disc">
                  <li>student first name</li>
                  <li>student surname</li>
                  <li>combined EFTSL</li>
                  <li>enrolment stage</li>
                  <li>enrolment status</li>
                  <li>supervisor desc</li>
                  <li>super_load_pcent</li>
                </ul>
              </li>
              <li>
                For each HDR <code>student_id</code>, <code>employee_no</code> and <code>unit_code</code> must not be
                empty.
              </li>
            </ul>
          </div>
        </div>
      </ScrollArea>
    </div>
  );
}
